import React, {Component} from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import FlexView from "react-flexview";
import {availability, defaultFilter, used, voucherSubTypeOptions, voucherType} from "../config";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleDDL from "../../../../modules/SimpleDDL";
import * as R from "ramda";
import SimpleButton from "../../../../modules/commons/SimpleButton";

class MasterVoucherFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filter: defaultFilter[this.props.tab],
            voucherTypeOptions: voucherType,
            voucherSubTypeOptions: voucherSubTypeOptions,
            availabilityOptions: availability,
            usedOptions: used,
        };
    };

    componentDidMount() {
        if (!R.isEmpty(this.props.submittedFilter)) {
            this.setState((prevValue) => ({
                ...prevValue,
                filter: this.props.submittedFilter,
            }));
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                filter: defaultFilter[this.props.tab],
            }));
        }
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.filter?.voucherType?.value !== this.state.filter?.voucherType?.value) {
            this.setState((prevValue) => ({
                ...prevValue,
                filter: {
                    ...prevValue.filter,
                    subVoucherType: null,
                    spesificJob: null,
                    spesificPart: null,
                },
            }));
        }
        if (prevState.filter?.subVoucherType?.value !== this.state.filter?.subVoucherType?.value) {
            this.setState((prevValue) => ({
                ...prevValue,
                filter: {
                    ...prevValue.filter,
                    spesificJob: null,
                    spesificPart: null,
                },
            }));
        }
    };

    handleChangeValue = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            filter: {
                ...prevValue.filter,
                [name]: value,
            },
        }));
    };

    handleResetValue = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filter: defaultFilter[this.props.tab],
        }));
    };

    handleSubmit = () => {
        this.props.onSubmit(this.state.filter);
    };

    render() {
        return (
            <SimpleModal
                title="Filter Data Voucher"
                visible={this.props.visible}
                onClickClose={this.props.onClickClose}
                styles={{width: "50%"}}
                content={
                    <ModalContainer>
                        <FlexView column>
                            {this.props.tab === "master" && (
                                <>
                                    <SimpleInput
                                        name="voucherName"
                                        label="Nama Voucher"
                                        value={this.state.filter?.voucherName || null}
                                        onChange={({target}) => this.handleChangeValue(target.name, target.value)}
                                    />
                                    <SimpleDDL
                                        id="select_options_voucher_type"
                                        box="search"
                                        name="voucherType"
                                        label="Jenis Voucher"
                                        options={this.state.voucherTypeOptions}
                                        value={this.state.filter?.voucherType || {}}
                                        onChange={(value, {name}) => this.handleChangeValue(name, value)}
                                    />
                                    <SimpleDDL
                                        id="select_options_voucher_sub_type"
                                        box="search"
                                        name="subVoucherType"
                                        label="Sub Jenis Voucher"
                                        options={this.state.voucherSubTypeOptions}
                                        readOnly={this.state.filter?.voucherType?.value !== "BENGKEL"}
                                        value={this.state.filter?.subVoucherType || {}}
                                        onChange={(value, {name}) => this.handleChangeValue(name, value)}
                                    />
                                    <SimpleInput
                                        name="spesificJob"
                                        label="Spesifik Job"
                                        readOnly={this.state.filter?.subVoucherType?.value !== "JOB"}
                                        value={this.state.filter?.spesificJob || null}
                                        onChange={({target}) => this.handleChangeValue(target.name, target.value)}
                                    />
                                    <SimpleInput
                                        name="spesificPart"
                                        label="Spesifik Part"
                                        readOnly={this.state.filter?.subVoucherType?.value !== "PART"}
                                        value={this.state.filter?.spesificPart || null}
                                        onChange={({target}) => this.handleChangeValue(target.name, target.value)}
                                    />
                                    <SimpleDDL
                                        id="select_options_availability"
                                        box="search"
                                        name="availibility"
                                        label="Availability"
                                        options={this.state.availabilityOptions}
                                        value={this.state.filter?.availibility || {}}
                                        onChange={(value, {name}) => this.handleChangeValue(name, value)}
                                    />
                                </>
                            )}
                            {this.props.tab === "user" && (
                                <>
                                    <SimpleInput
                                        name="memberName"
                                        label="Nama Member"
                                        value={this.state.filter?.memberName || null}
                                        onChange={({target}) => this.handleChangeValue(target.name, target.value)}
                                    />
                                    <SimpleInput
                                        name="memberId"
                                        label="Member ID"
                                        value={this.state.filter?.memberId || null}
                                        onChange={({target}) => this.handleChangeValue(target.name, target.value)}
                                    />
                                    <SimpleDDL
                                        id="select_options_used"
                                        box="search"
                                        name="used"
                                        label="Used"
                                        options={this.state.usedOptions}
                                        value={this.state.filter?.used || {}}
                                        onChange={(value, {name}) => this.handleChangeValue(name, value)}
                                    />
                                </>
                            )}
                            <FlexView style={{justifyContent: "center", gap: "20px"}}>
                                <SimpleButton onClick={this.handleResetValue}>Hapus</SimpleButton>
                                <SimpleButton onClick={this.handleSubmit}>Terapkan</SimpleButton>
                            </FlexView>
                        </FlexView>
                    </ModalContainer>
                }
            />
        );
    };
}

export default MasterVoucherFilter;